import FirmwareIcon from "@mui/icons-material/Security";

export interface FirmwareVersionHelper {
  description: string;
  icon: any;
  tooltip: string;
  colour: string;
}

const oldFirmwareColour = "var(--status-warning)";
const currentFirmwareColour = "var(--status-ok)";
const unknownFirmwareColour = "var(--status-warning)";

export function getFirmwareVersionHelper(
  version: string,
  available: string
): FirmwareVersionHelper {
  const firmwareIcon = <FirmwareIcon />;
  const oldFirmwareIcon = <FirmwareIcon style={{ color: oldFirmwareColour }} />;
  const currentFirmwareIcon = <FirmwareIcon style={{ color: currentFirmwareColour }} />;
  const unknownFirmwareIcon = <FirmwareIcon style={{ color: unknownFirmwareColour }} />;
  let helper = {} as FirmwareVersionHelper;
  if (!version || version === "") {
    helper.description = "Unknown version";
    helper.icon = oldFirmwareIcon;
    helper.tooltip = "We don't know what version your device is, it may behave unexpectedly";
    helper.colour = oldFirmwareColour;
  } else if (version.startsWith("!")) {
    const cleanVersion = version.substring(1);
    helper.description = cleanVersion;
    helper.icon = unknownFirmwareIcon;
    helper.tooltip = "Firmware " + cleanVersion + " was reported by the device but is missing from the firmware list";
    helper.colour = unknownFirmwareColour;
  } else if (available !== "" && version !== available) {
    helper.description = version;
    helper.icon = oldFirmwareIcon;
    helper.tooltip =
      "A firmware upgrade is available, some features may be disabled for out-of-date devices";
    helper.colour = oldFirmwareColour;
  } else if (available === "") {
    helper.description = version;
    helper.icon = firmwareIcon;
    helper.tooltip = "Running version " + version;
    helper.colour = "";
  } else {
    helper.description = version;
    helper.icon = currentFirmwareIcon;
    helper.tooltip = "Your device is running the latest firmware";
    helper.colour = currentFirmwareColour;
  }
  return helper;
}

export function getFirmwareVersionColour(outdated: boolean): string {
  return outdated ? oldFirmwareColour : currentFirmwareColour;
}
